// extracted by mini-css-extract-plugin
module.exports = {"container":"Menu_container__2-885","fadeIn":"Menu_fadeIn__3zEy9","icon":"Menu_icon__2eVPN","arrow":"Menu_arrow__2MQRZ","linksList":"Menu_linksList__-JoZv"};